var _rect, _path, _path2, _path3, _rect2, _rect3, _rect4, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 141,
    viewBox: "0 0 140 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30.6816,
    width: 80,
    height: 93,
    rx: 5,
    fill: "#F0C1D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 59.6816H90",
    stroke: "#002E52",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65 79.6816H90",
    stroke: "#002E52",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65 98.6816H90",
    stroke: "#002E52",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 52.6816,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#002E52"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 72.6816,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#002E52"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 92.6816,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#002E52"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3131 34.6816C57.8654 34.6816 58.3131 34.2339 58.3131 33.6816V26.1589C58.3131 20.3725 63.004 15.6816 68.7904 15.6816H71.1187C76.9051 15.6816 81.596 20.3725 81.596 26.1589V33.6816C81.596 34.2339 82.0437 34.6816 82.596 34.6816H88.9091C90.0137 34.6816 90.9091 35.5771 90.9091 36.6816V42.6816C90.9091 43.7862 90.0137 44.6816 88.9091 44.6816L51 44.6816C49.8954 44.6816 49 43.7862 49 42.6816V36.6816C49 35.5771 49.8954 34.6816 51 34.6816H57.3131ZM73.447 24.9947C73.447 26.9235 71.8834 28.4871 69.9545 28.4871C68.0257 28.4871 66.4621 26.9235 66.4621 24.9947C66.4621 23.0659 68.0257 21.5022 69.9545 21.5022C71.8834 21.5022 73.447 23.0659 73.447 24.9947Z",
    fill: "#E283B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/Test.af3d7ef8d7755058e448a28995f744b6.svg";
export { ForwardRef as ReactComponent };